const LogoSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
      <mask id="mask0_5067_24380" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="24">
        <path
          d="M14.6518 19.4102C13.2834 19.413 12.1487 18.9308 11.1887 17.9426C10.4239 17.1574 9.95581 16.184 9.75725 14.9902L23.9921 14.981L23.9668 13.9418C23.8985 10.9921 22.9723 8.61202 21.2212 6.87149C19.4647 5.13103 17.2767 4.2466 14.7055 4.25002C12.1237 4.25359 9.92408 5.2047 8.17054 7.08621C6.43281 8.95126 5.55063 11.2158 5.5499 13.82C5.55451 16.4241 6.43089 18.6804 8.16757 20.5348C9.91516 22.4053 12.1576 23.354 14.8249 23.3492C18.5614 23.3457 21.4171 21.5355 23.3071 17.9574L23.7907 16.9978L19.2733 16.9634C18.1579 18.6087 16.635 19.4095 14.6518 19.4102ZM14.7304 8.28857C15.9705 8.2875 17.0339 8.64622 17.9797 9.38015C18.5959 9.85882 19.0478 10.4426 19.3519 11.1639L10.2967 11.1658C11.1782 9.23149 12.6349 8.28535 14.7304 8.28857Z"
          fill="#E00000"
        />
        <path
          d="M27.0592 16.6502L27.4068 17.9169L26.1988 17.4297L25.1193 18.1605L25.2047 16.8451L24.1838 16.0277L25.445 15.7029L25.8992 14.4687L26.5888 15.5839L27.8875 15.638L27.0592 16.6502Z"
          fill="#E00000"
        />
        <path
          d="M26.7222 9.889L27.6629 10.7984L26.3803 11.0041L25.8192 12.195L25.2258 11.0203L23.9378 10.8471L24.8569 9.91606L24.6216 8.61691L25.7814 9.21777L26.9251 8.58984L26.7222 9.889Z"
          fill="#E00000"
        />
        <path
          d="M23.237 4.3616L24.4984 4.67014L23.4883 5.49836L23.5901 6.81375L22.4997 6.0938L21.2972 6.60264L21.6338 5.32513L20.7892 4.3237L22.0879 4.25333L22.7665 3.13281L23.237 4.3616Z"
          fill="#E00000"
        />
        <path
          d="M17.3469 1.31214L18.5975 0.938633L18.1273 2.16742L18.8597 3.25546L17.5609 3.18509L16.7701 4.22983L16.4332 2.95232L15.2092 2.50845L16.2994 1.79391L16.3367 0.478516L17.3469 1.31214Z"
          fill="#E00000"
        />
        <path
          d="M10.818 1.67928L11.7157 0.726562L11.919 2.02572L13.0949 2.5941L11.9352 3.19495L11.7643 4.49952L10.8449 3.56846L9.56226 3.80664L10.1554 2.63199L9.53525 1.47358L10.818 1.67928Z"
          fill="#E00000"
        />
        <path
          d="M5.68478 5.20509L5.76957 3.89454L6.74816 4.76513L8.01096 4.44484L7.49657 5.65311L8.19195 6.76983L6.89643 6.6454L6.06611 7.65508L5.77574 6.37025L4.56837 5.87378L5.68478 5.20509Z"
          fill="#E00000"
        />
        <path
          d="M4.95505 4.28906L4.95509 5.18544L3.84932 5.90948L4.95515 6.45011L4.95594 23.147L0.323153 23.147L0.322266 4.28906L4.95505 4.28906Z"
          fill="#E00000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4116 19.6181C22.5561 20.9464 21.5458 21.9883 20.3862 22.7413L20.4278 22.7572C21.4021 23.1131 22.5216 23.2911 23.7863 23.2911C25.1259 23.2911 26.2923 23.0991 27.2853 22.715C28.2783 22.3309 29.1027 21.8016 29.7585 21.1271C30.4236 20.4526 30.9154 19.6563 31.234 18.7382C31.5619 17.8201 31.7258 16.8271 31.7258 15.7592L31.7258 4.26798L27.3837 4.26798L27.3837 9.95318L28.4824 11.0595L27.3837 11.2431L27.3837 15.1279L28.7706 15.1857L27.506 16.7311L28.0366 18.6649L26.8143 18.1719C26.7358 18.3151 26.6493 18.4476 26.5546 18.5696C26.0112 19.2816 25.1259 19.6376 23.8987 19.6376C23.7302 19.6376 23.5679 19.6311 23.4116 19.6181Z"
          fill="#E00000"
        />
      </mask>
      <g mask="url(#mask0_5067_24380)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.5445 -7.5957C32.3764 -7.5957 36.1593 -3.81283 36.1593 2.01913V23.1402C36.1593 28.9721 32.3764 32.755 26.5445 32.755H5.42342C-0.408529 32.755 -4.19141 28.9721 -4.19141 23.1402V2.01913C-4.19141 -3.81283 -0.408529 -7.5957 5.42342 -7.5957H26.5445Z"
          fill="#222222"
        />
        <mask id="mask1_5067_24380" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-5" y="-8" width="42" height="41">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.5445 -7.5957C32.3764 -7.5957 36.1593 -3.81283 36.1593 2.01913V23.1402C36.1593 28.9721 32.3764 32.755 26.5445 32.755H5.42342C-0.408529 32.755 -4.19141 28.9721 -4.19141 23.1402V2.01913C-4.19141 -3.81283 -0.408529 -7.5957 5.42342 -7.5957H26.5445Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_5067_24380)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-6.54559 26.871L-3.35116 31.9149L42.884 -14.3203L-7.8125 -11.5146L-6.54559 26.871Z"
            fill="url(#paint0_linear_5067_24380)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-4.69826 33.2583L38.8469 -10.2868L21.3616 -12.6406L-5.70703 14.9323L-4.69826 33.2583Z"
            fill="url(#paint1_linear_5067_24380)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.6622 11.9058L12.2836 36.7887L-4.69727 33.258L38.8478 -10.2871L36.6622 11.9058Z"
            fill="url(#paint2_linear_5067_24380)"
          />
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_5067_24380" x1="30.22" y1="-18.0591" x2="-2.67039" y2="-16.9202" gradientUnits="userSpaceOnUse">
          <stop stopColor="#888888" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient id="paint1_linear_5067_24380" x1="-3.64574" y1="-3.2451" x2="-13.1619" y2="22.6245" gradientUnits="userSpaceOnUse">
          <stop stopColor="#393939" stopOpacity="0.01" />
          <stop offset="1" stopColor="#353535" />
        </linearGradient>
        <linearGradient id="paint2_linear_5067_24380" x1="18.7654" y1="-18.7995" x2="-16.0407" y2="13.1189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4B4B4B" />
          <stop offset="0.61745" stopColor="#2A2A2A" />
          <stop offset="1" stopColor="#040404" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoSvg;
